import { spaces } from '@kimuno/theme';
import { Box } from '@mui/material';
import type React from 'react';
import { useSelector } from 'react-redux';

import { selectUser } from '../../../../reducers/user.selectors';
import useScreenSize from '../../../../utils/useScreenSize';
import ProfileAvatar from '../../../ProfileAvatar/ProfileAvatar';
import SearchBar from '../../../SearchBar';
import MobileTopBar from '../TopBar/MobileTopBar';

interface TopBarContentProps {
	customTopBarContent?: React.ReactNode;
	/** Controls rendered directly left of the profile avatar, on the same screen sizes */
	topBarActions?: React.ReactNode;
	hideAvatar?: boolean;
}

const TopBarContent = ({ customTopBarContent, topBarActions, hideAvatar }: TopBarContentProps) => {
	const { isXsScreen, isMdScreen, isLgScreen } = useScreenSize();
	const user = useSelector(selectUser);

	const isDesktopScreen = isMdScreen || isLgScreen;

	const searchContent = customTopBarContent || (!user?.isAiOnlyUser ? <SearchBar /> : null);

	return (
		<>
			{isXsScreen ? (
				!user?.isAiOnlyUser && <MobileTopBar />
			) : (
				<Box
					sx={{
						gap: spaces.md,
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						flex: '1 0 0',
						justifyContent: 'flex-end',
					}}
				>
					{!isXsScreen && searchContent && (
						<Box
							sx={{
								flex: '1 0 0',
								alignSelf: 'center',
							}}
						>
							{searchContent}
						</Box>
					)}
					{isDesktopScreen && topBarActions}
					{!hideAvatar && isDesktopScreen && <ProfileAvatar />}
				</Box>
			)}
		</>
	);
};

export default TopBarContent;
